import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import moment from 'moment';
import {
  DataSet,
  Timeline,
  TimelineOptions,
  TimelineGroup,
} from 'vis-timeline/standalone';
import _ from 'lodash';
import { TimelineService } from '../../../../core/services/timeline.service';


@Component({
  selector: 'app-running-timeline',
  standalone: true,
  imports: [],
  templateUrl: './running-timeline.component.html',
  styleUrls: ['./running-timeline.component.css'],
})
export class RunningTimelineComponent implements OnInit, OnDestroy {
  @ViewChild('timelineContainer', { static: true })
  timelineContainer!: ElementRef;

  timelineDataSet = new DataSet<any>([]);
  timeline?: Timeline;
  currentDate = moment().format('MMM Do YYYY  h:mm:ss A');
  timelineHeight = '0px';

  private timeChangeSub?: Subscription;
  private heightsInterval?: any;
  private timelineEntitySub?: Subscription;
  private alertReadSub?: Subscription;

  DX = 100;

  @Output() timelineClick = new EventEmitter<{ arcliveid: any, listid: any }>();

  constructor(
    private timelineService: TimelineService,
  ) {}

  // Add method to add alert to timeline
  addAlertToTimeline(alertTime: Date) {
    const item = {
      id: Date.now(), // Unique ID
      group: 'event',
      start: alertTime,
      end: new Date(alertTime.getTime() + 1000), // 1 second duration
      type: 'box',
      className: 'alert-item',
      content: '<div style="background-color: #000;opacity: 0.3"><i class="fa fa-exclamation-triangle"></i></div>'
    };
    this.timelineDataSet.add(item);
  }

  // Add method to decode JWT token
  decodeJWT(token: string) {
    try {
      // Split the token into parts
      const parts = token.split('.');
      if (parts.length !== 3) {
        throw new Error('Invalid token format');
      }

      // Decode the payload (second part)
      const payload = JSON.parse(atob(parts[1]));
      
      // Log the decoded data
      
      // If the payload contains a timestamp, you can add it to the timeline
      if (payload.iat) {
        const alertTime = new Date(payload.iat * 1000); // Convert Unix timestamp to Date
        this.addAlertToTimeline(alertTime);
      }

      return payload;
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  }

  ngOnInit() {
    this.resetTimeline();

    // Update time every DX ms
    this.timeChangeSub = interval(this.DX).subscribe(() => this.tick());

    // Adjust timeline height every 500 ms
    this.heightsInterval = setInterval(() => this.setHeights(), 500);

    // Subscribe to new timeline items
    this.timelineEntitySub = this.timelineService.timelineEntity$.subscribe((event: { type: any; payload: any; }) => {
      if (event?.type === this.timelineService.NEW__TIMELINE_ENTITY) {
        this.addTimelineItem(event.payload);
      }
    });

    this.alertReadSub = this.timelineService.alertRead$.subscribe(item => {
      if (item.status === 'active') {
        const data = this.timelineDataSet.get(item.timelineAlertId) as any;
        if (data && data.content) {
          const cont = data.content.replace(';"', '; opacity: 0.3"');
          this.timelineDataSet.update({ id: item.timelineAlertId, content: cont });
        }
      }
    });
  }

  ngOnDestroy() {
    this.timeChangeSub?.unsubscribe();
    this.timelineEntitySub?.unsubscribe();
    if (this.timeline) {
      this.timeline.destroy();
    }
    clearInterval(this.heightsInterval);
    this.alertReadSub?.unsubscribe();
  }

  tick() {
    const now = new Date().getTime();
    this.updateTime(now);
  }

  updateTime(newTime: number) {
    this.currentDate = moment(newTime).format('MMM Do YYYY  h:mm:ss A');
  }
  
resetTimeline() {
  const h = '70px';
  const allgroups = [
    {
      id: this.timelineService.EVENT,
      content: '<i class="fa fa-exclamation-triangle fa-lg" aria-hidden="true" title="alerts"></i>'
    }
  ];
  const groupSubset = allgroups;

  const options: TimelineOptions = {
    width: '100%',
    height: h,
    selectable: false,
    stack: false,
    moveable: false,
    showCurrentTime: false,
    zoomable: false,
    format: {
      minorLabels: {
        millisecond: 'SSS',
        second: ':s',
        minute: 'hh:mm',
        hour: 'hh:mm',
        weekday: 'ddd D',
        day: 'D',
        month: 'MMM',
        year: 'YYYY',
      },
      majorLabels: {
        millisecond: 'HH:mm:ss',
        second: 'HH:mm',
        minute: 'ddd D MMMM',
        hour: 'ddd D MMMM',
        weekday: 'MMMM YYYY',
        day: 'MMMM YYYY',
        month: 'YYYY',
        year: '',
      },
    },
    margin: {
      axis: 20,
      item: {
        horizontal: 0,
        vertical: 0,
      },
    },
    start: moment().subtract(5, 'minutes').toDate(),
    rollingMode: {
      follow: true,
      offset: 1,
    },
    timeAxis: {
      scale: 'second',
      step: 10,
    },
    template: function (item) {
    return item.content;
  },
    groupTemplate: (group) => {
      const container = document.createElement('div');
      if (group && group?.content) {
        container.innerHTML = group?.content;
      } else {
        container.innerHTML = '';
      }
      return container;
    },
  };

  if (!this.timeline) {
    this.timeline = new Timeline(
      this.timelineContainer.nativeElement,
      this.timelineDataSet,
      groupSubset,
      options
    );
    this.timeline.on('click', (properties) => this.onClick(properties));
  } else {
    this.timeline.setGroups(groupSubset);
  }

  this.currentDate = moment().format('MMM Do YYYY  h:mm:ss A');

  for (const item of this.timelineService.data.timelineItems) {
    if (!this.timelineDataSet.get(item.timelineAlertId)) {
      this.addTimelineItem(item);
    }
  }
}

  // resetTimeline() {
  //   // Define groups as per your original logic
    
  //   const groups: TimelineGroup[] = [
  //     {
  //       id: 'event',
  //        content: "<i class='fas fa-home fa-lg'></i>"
  //     },
  //   ];

  //   const options: TimelineOptions = {
  //     width: '100%',
  //     height: '70px',
  //     selectable: false,
  //     stack: false,
  //     moveable: false,
  //     showCurrentTime: false,
  //     zoomable: false,
  //     format: {
  //       minorLabels: {
  //         millisecond: 'SSS',
  //         second: ':s',
  //         minute: 'hh:mm',
  //         hour: 'hh:mm',
  //         weekday: 'ddd D',
  //         day: 'D',
  //         month: 'MMM',
  //         year: 'YYYY',
  //       },
  //       majorLabels: {
  //         millisecond: 'HH:mm:ss',
  //         second: 'HH:mm',
  //         minute: 'ddd D MMMM',
  //         hour: 'ddd D MMMM',
  //         weekday: 'MMMM YYYY',
  //         day: 'MMMM YYYY',
  //         month: 'YYYY',
  //         year: '',
  //       },
  //     },
  //     margin: {
  //       axis: 20,
  //       item: {
  //         horizontal: 0,
  //         vertical: 0,
  //       },
  //     },
  //     start: moment().subtract(5, 'minutes').toDate(),
  //     rollingMode: {
  //       follow: true,
  //       offset: 1,
  //     },
  //     timeAxis: {
  //       scale: 'second',
  //       step: 10,
  //     },
  //   };
  //   if (!this.timeline) {
  //     this.timeline = new Timeline(
  //       this.timelineContainer.nativeElement,
  //       this.timelineDataSet,
  //       groups,
  //       options
  //     );
  //     this.timeline.on('click', (properties) => this.onClick(properties));
  //   } else {
  //     this.timeline.setGroups(groups);
  //   }
  // }

  onClick(properties: any) {
    const item = this.timelineDataSet.get(properties.item) as any;
    if (item && item.arcliveid) {
      this.timelineClick.emit({ arcliveid: item.arcliveid, listid: item.alertId });
      this.timelineService.timelineClick$.next({ arcliveid: item.arcliveid, listid: item.alertId });
    }
  }

  zoomIn() {
    this.zoom(-0.5);
  }

  zoomOut() {
    this.zoom(0.5);
  }

  zoom(percentage: number) {
    if (!this.timeline) return;

    const range = this.timeline.getWindow();
    const interval = range.end.valueOf() - range.start.valueOf();

    this.timeline.setWindow(
      new Date(range.start.valueOf() - interval * percentage),
      new Date(range.end.valueOf() + interval * percentage)
    );
  }

  setHeights() {
    // For demonstration: you can calculate dynamic height or get from window size or service
    const newHeight = '70px'; // fixed or dynamic
    if (this.timelineHeight !== newHeight) {
      this.timelineHeight = newHeight;
      if (this.timeline) {
        this.timeline.setOptions({ height: this.timelineHeight });
      }
    }
  }


addTimelineItem(item: any) {
  const div = this.buildTimelineContent(item);

  this.timelineDataSet?.add({
    id: item.timelineAlertId,
    icon_path: item.img || (item.entity && item.entity.icon),
    start: new Date(item.timestamp || (item.entity && item.entity.timestamp)),
    content: div, // HTMLElement
    style: 'background-color: #000; padding: 0px;',
    group: item.type,
    arcliveid: item.timelineAlertId,
    listid: item.listId,
    alertId: item?.entity?.object?.id,
  });
}

buildTimelineContent(item: any): HTMLElement {
  const faClass = item?.entity?.object?.incidentCategory?.iconCode || 'fa fa-exclamation-triangle';
  const viewed = item?.entity?.object?.viewedAt && item.entity.object.viewedAt !== 'Infinity';

  const div = document.createElement('div');
  div.style.backgroundColor = '#000';
  div.style.opacity = viewed ? '0.3' : '1';
  div.style.display = 'flex';
  div.style.justifyContent = 'center';
  div.style.alignItems = 'center';
  div.style.height = '100%';

  const icon = document.createElement('i');
  icon.className = faClass;
  icon.style.fontSize = '18px';
  icon.style.display = 'block';
  icon.style.marginTop = '8px';

  div.appendChild(icon);

  return div;
}
}
